import { SocialSecurityBenefitCardConfiaPage } from './ConfiaPage';
import { SocialSecurityBenefitCardSignedPage } from './SignedPage';
import { SocialSecurityBenefitCardEnrichPersonalData } from './EnrichPersonalData';
import { SocialSecurityBenefitCardLogin } from './Login';
import { SocialSecurityBenefitCardSocialSecurityCards } from './SocialSecurityCards';
import { SocialSecurityBenefitCardPersonalDocument } from './PersonalDocument';

export const SocialSecurityBenefitCardTheme = {
    ConfiaPage: SocialSecurityBenefitCardConfiaPage,
    SignedPage: SocialSecurityBenefitCardSignedPage,
    EnrichPersonalData: SocialSecurityBenefitCardEnrichPersonalData,
    Login: SocialSecurityBenefitCardLogin,
    SocialSecurityCards: SocialSecurityBenefitCardSocialSecurityCards,
    PersonalDocument: SocialSecurityBenefitCardPersonalDocument,
} as const;